import client from "../api-client";
import toQueryString from "../toQueryString";

const URL = "/proxy_list.php";

export const get = (filters) => {
  let params = toQueryString(filters);
  return client(URL + `?${params}`).then(async (response) => {
    return await response;
  });
};
